import React from 'react';
import PropTypes from 'prop-types';
import { SovosToolbar, SovosToolbarGroup } from 's1-ui/sovos-toolbar';
import SovosMonthSelector from 's1-ui/sovos-month-selector';

const LinesPeriodPicker = ({ lineDataActions, yearsBeyond, yearsBefore }) => {
  const handlePeriodChange = period => {
    const realMonthValue = period.month + 1;
    const periodId = `${period.year}${(realMonthValue.toString().length===1)?'0':''}${realMonthValue}`;
    lineDataActions.fetchLineDataInformation(periodId);
  };
  const actualDate = new Date();

  return (
    <div className={ 'invoices-period-picker' }>
      <SovosToolbar>
        <SovosToolbarGroup>
          <SovosMonthSelector
            minDate={ new Date(actualDate.getFullYear() - yearsBefore, 0) }
            maxDate={ new Date(actualDate.getFullYear() + yearsBeyond, 11) }
            format="number"
            onChange={ handlePeriodChange }
            style={ { marginTop: '-15px' } }
          />
        </SovosToolbarGroup>
      </SovosToolbar>
      
    </div>
  );
};

LinesPeriodPicker.propTypes = {
  lineDataActions: PropTypes.shape({
    getLineDataInformationByPeriod: PropTypes.func
  }),
  yearsBeyond: PropTypes.number,
  yearsBefore: PropTypes.number
};

LinesPeriodPicker.defaultProps = {
  yearsBeyond: 2,
  yearsBefore: 2
};

export default LinesPeriodPicker;


// WEBPACK FOOTER //
// ./src/components/dashboard/comp/linesData/linesPeriodPicker/LinesPeriodPicker.js